<div class="file-upload">
  <div
    class="file-upload-disabled-overlay"
    *ngIf="disabled"
    tooltipPosition="top"
    [pTooltip]="disabledText | translation"></div>
  <div
    class="file-upload-wrapper"
    [ngClass]="{ 'center-align': centerField }"
    (drop)="onFileDropped($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (click)="fileInput.click()">
    <div class="file-upload-prompt">
      <div class="ddinfo-container">
        <i
          class="fas fa-cloud-upload-alt"
          style="font-size: 5rem; color: #2ea3f2; width: 86px"></i>

        <div class="ddinfo">{{ 'drag_and_drop_file' | translation }}</div>
        <div class="ddinfo">
          {{ 'or' | translation }}
          <span class="ddinfo--underline">{{ 'browse' | translation }}</span>
        </div>
        <div
          *ngIf="canUpload && files?.length > 0"
          class="upload-button-container">
          <app-button
            [isProcessing]="isUploading"
            (click)="triggerUpload($event)"
            [disabled]="isUploading || allFilesUploaded">
            {{ 'upload' | translation }}
          </app-button>
        </div>
      </div>
    </div>
    <div
      *ngIf="files?.length > 0"
      style="flex: 1; overflow: auto; max-height: 50vh; width: 100%">
      <div
        class="file-upload-details"
        *ngFor="let file of files; let i = index">
        <div
          style="
            width: calc(100% - 40px);
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 10px;
            overflow: hidden;
            min-width: 0;
          ">
          <div
            style="
              display: flex;
              align-items: center;
              gap: 5px;
              width: 100%;
              overflow: hidden;
              max-width: 100%;
            ">
            <p
              style="
                text-align: left;
                margin: 0px;
                font-family: Montserrat, sans-serif;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: calc(100% - 20px);
                flex: 1;
                min-width: 3ch;
              ">
              {{ file.name }}
            </p>
            <i
              *ngIf="file?.error"
              [pTooltip]="file?.error"
              tooltipPosition="left"
              class="fa-solid fa-circle-exclamation error-color"
              style="flex-shrink: 0"></i>
          </div>
          <p-progressbar
            *ngIf="!file?.error && (file.isUploading || file?.progress)"
            [value]="file?.progress"
            [showValue]="false"
            class="w-full">
          </p-progressbar>
        </div>
        <p-button
          variant="text"
          (click)="removeFile($event, i)"
          [style]="{
            'min-width': '40px',
            'flex-shrink': '0',
            'margin-left': 'auto',
          }">
          <i class="fas fa-times"></i>
        </p-button>
      </div>
    </div>

    <input
      type="file"
      (change)="onFileSelected($event)"
      [attr.accept]="acceptedFileTypes"
      [multiple]="allowMultiple"
      hidden
      #fileInput />
  </div>
</div>
